export default __webpack_public_path__ + "static/image3-934264e91d78f5b1ab926e1ca0b6e851.webp";